/**
 * Normalize filter objects for the forms index (GET /forms), matching entityActionFactory.
 * Arrays of objects with `id` become id arrays; some keys pass through unchanged.
 */
const optimizeIndexQueryFilters = filters => {
  if (typeof filters !== 'object') {
    return filters;
  }
  const cleanedFilters = {};
  Object.keys(filters).forEach(key => {
    if (!Array.isArray(filters[key]) || ['jobPiece', 'pieceOther', 'asset'].includes(key) // pass through queries that need more than ID
    ) {
      cleanedFilters[key] = filters[key];
    } else {
      const cleanedItems = filters[key].filter(i => i !== null).map(i => i.id === undefined ? i : i.id);
      cleanedFilters[key] = cleanedItems;
    }
  });
  return cleanedFilters;
};
export default optimizeIndexQueryFilters;